export default {
  showStages: 'Rezeptschritte anzeigen',
};
